import { motcode_cookie_handler } from './event.js';

// Module name
export const MODULE_NAME = 'motcodeman';

export let global_vars = {};

export function initialize(global) {
    // Setup mot code handler
    motcode_cookie_handler(global);
}
